module.exports = __webpack_public_path__ + "media/assets/images/aphasia/logo-b191c1ea6b18b465312eae9bb74096d1.gif";